import { render, staticRenderFns } from "./boots.vue?vue&type=template&id=2dfe3a7f"
import script from "./boots.vue?vue&type=script&lang=js"
export * from "./boots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports